import React from 'react';
import PropTypes from 'prop-types';

import './warranty-conditions-box.scss';

export function WarrantyConditionsBox(props) {
  const { children } = props;

  return <div className="warranty-conditions-box bg-cool-gray-100 p-0_75 text-cool-gray-40">{children}</div>;
}

WarrantyConditionsBox.propTypes = {
  children: PropTypes.node.isRequired,
};
